"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconClockLarge = function IconClockLarge(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M23.999 4c11.046 0 20 8.954 20 20s-8.954 20-20 20-20-8.954-20-20 8.954-20 20-20m.494 4.5a.5.5 0 0 1-1 0V6.007c-3.04.084-5.892.922-8.375 2.333l1.174 2.033a.5.5 0 0 1-.866.5l-1.164-2.015c-2.2 1.418-4.07 3.301-5.473 5.511l2.179 1.258a.5.5 0 0 1-.5.866l-2.19-1.264a17.9 17.9 0 0 0-2.271 8.267H8.5a.5.5 0 0 1 .001 1H6.006a17.9 17.9 0 0 0 1.867 7.507l2.273-1.242a.5.5 0 0 1 .48.877l-2.284 1.248a18.1 18.1 0 0 0 5.817 6.187l1.267-2.193a.5.5 0 0 1 .866.5l-1.281 2.219a17.9 17.9 0 0 0 8.502 2.394V39.5a.501.501 0 0 1 1 0v2.492a17.9 17.9 0 0 0 8.235-2.26l-1.265-2.192a.5.5 0 1 1 .866-.5l1.26 2.182a18.1 18.1 0 0 0 6.06-6.363l-2.235-1.221a.5.5 0 1 1 .48-.877l2.224 1.216a17.9 17.9 0 0 0 1.854-7.475h-2.5a.5.5 0 0 1 0-1.001h2.5a17.9 17.9 0 0 0-2.321-8.358l-2.338 1.35a.5.5 0 0 1-.5-.866l2.322-1.34a18.1 18.1 0 0 0-5.673-5.588l-1.254 2.174a.5.5 0 0 1-.866-.5l1.257-2.178a17.9 17.9 0 0 0-8.126-2.188zM24 12a1 1 0 0 1 1 1v8.639A2.5 2.5 0 0 1 26.355 23H33l.102.005A1 1 0 0 1 33 25h-6.691a2.498 2.498 0 0 1-4.766-1.052c0-1.008.598-1.875 1.457-2.27v-8.679A1 1 0 0 1 24 12m.043 10.448a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
  })));
};

export { IconClockLarge, IconClockLarge as default };
